import { on, reducer } from "ts-action";

import { loadWahlErgebnis } from "./wahlen-actions.js";
import type { WahlErgebnis } from "../service/wahlen-service.js";

export interface WahlenState {
  /** Die zuletzt geladene Sicht — samt ID, damit die Seite fremde Reste erkennt. */
  ergebnis?: WahlErgebnis;
}

const initialState: WahlenState = {};

/** Nur ablegen — der Ladezustand gehört den zentralen Loading-Effects. */
export const wahlenReducer = reducer<WahlenState>(
  initialState,
  on(loadWahlErgebnis.success, (state, { payload }) => ({ ...state, ergebnis: payload })),
);
